import { Box, makeStyles } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  loadingContent: {
    marginLeft: 2,
    marginRight: 2,
    width: ({ size }) => size ?? 6,
    height: ({ size }) => size ?? 6,
    backgroundColor: ({ color }) => theme.colors[color] ?? color ?? 'currentColor',
    borderRadius: '50%',
    animation: '0.6s infinite alternate $fade',
  },

  loadingContent2: { animationDelay: '0.2s' },
  loadingContent3: { animationDelay: '0.4s' },

  '@keyframes fade': {
    from: { opacity: 1 },
    to: { opacity: 0.44 },
  },
}));

const Loading = React.forwardRef((props, ref) => {
  const { color = 'brandMedium', size, ...otherProps } = props;

  const classes = useStyles({ color, size });
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight={32}
      {...otherProps}
      ref={ref}
    >
      <div className={classes.loadingContent} />
      <div className={classnames(classes.loadingContent, classes.loadingContent2)} />
      <div className={classnames(classes.loadingContent, classes.loadingContent3)} />
    </Box>
  );
});

Loading.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};
Loading.defaultProps = {
  color: undefined,
  size: undefined,
};

export default Loading;
